import {useEffect} from 'react';
import {useSearchParams} from 'react-router-dom';
import {diApi} from '@di-shared/api/di';
import environmentStore from '@di-shared/features/environment/environmentStore';
import {WebviewUtils} from '@shared/webviewUtils';

/**
 * 결제 승인 api 후 닫히면 됨
 *
 * hmg-Pay return url 스팩:
 *    Redirect: GET {RETURN_URL}? paymentKey=(paymentKey) &merchantTransactionNo=(merchantTransactionNo)&merchantCode= (merchantCode}
 *
 * paymentKey 가 있으면 성공, 없으면 실패임
 *
 * @see https://hmg.dooray.com/project/tasks/4119773533273679829
 */
function PaymentHmgPayCallbackPage() {
  const puid = environmentStore.getState().puid;
  const [searchParams] = useSearchParams();
  const paymentKey = searchParams.get('paymentKey');
  const merchantTransactionNo = searchParams.get('merchantTransactionNo');
  // const merchantCode = searchParams.get('merchantCode'); // 받기는 하지만 사용 안하는 값

  useEffect(() => {
    async function paymentComplete() {
      try {
        WebviewUtils.loading(true);
        /**
         * 서버로 받은 내용을 일단 던지면, 값의 여부에 따라서 서버에서 결제 상태를 판단
         */
        await diApi.publicServiceInspection.confirmPayment({
          requestBody: {
            puid,
            paymentKey: paymentKey!,
            merchantTransactionNo: merchantTransactionNo!,
          },
        });
      } finally {
        WebviewUtils.loading(false);
        // 결과 무관하게 웹뷰를 닫음
        WebviewUtils.close();
      }
    }

    paymentComplete();
  }, []);

  return null;
}

export default PaymentHmgPayCallbackPage;
